import { useMemo } from 'react';
import FileDocImg from '../assets/files/file-doc.png';
import FileDmcImg from '../assets/files/file-dcm.png';
import FileStlImg from '../assets/files/file-stl.png';
import FilePdfImg from '../assets/files/file-pdf.png';
import FileZipImg from '../assets/files/file-zip.png';

type PropsFileThumbnail = {
  name: string;
  width?: number;
  height?: number;
  alt?: string;
  onClick?: () => void;
}

enum FileTypes {
  RAR = '.rar',
  ZIP = '.zip',
  PDF = '.pdf',
  DCM = '.dcm',
  STL = '.stl'
}

export function FileThumbnail({
  name,
  width = 100,
  height = 100,
  alt = '',
  onClick = () => {
    return false;
  }
}: PropsFileThumbnail) {
  const image = useMemo(() => {
    if (name.toLowerCase().endsWith(FileTypes.ZIP) || name.toLowerCase().endsWith(FileTypes.RAR)) {
      return FileZipImg;
    }
    if (name.toLowerCase().endsWith(FileTypes.PDF)) {
      return FilePdfImg;
    }
    if (name.toLowerCase().endsWith(FileTypes.DCM)) {
      return FileDmcImg;
    }
    if (name.toLowerCase().endsWith(FileTypes.STL)) {
      return FileStlImg;
    }
    return FileDocImg;
  }, [name]);
  return (
    <img
      src={image}
      className="object-fit-cover shadow-1-strong rounded mb-2"
      alt={alt}
      width={width}
      height={height}
      onClick={onClick}
    />
  );
}

export default FileThumbnail;
